import { Flex } from '@ghq-abi/design-system';
import { Button } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { RowSelection } from '~/shared/hooks/useRowSelection';

interface BulkArchiveBarProps {
    selection: RowSelection;
    onArchiveSelected: () => void;
}

export function BulkArchiveBar({ selection, onArchiveSelected }: BulkArchiveBarProps) {
    const { t } = useTranslate();
    const { isSelectMode, selectedCount, toggleSelectMode } = selection;

    return (
        <Flex css={{ justifyContent: 'flex-end', gap: '$2', marginBottom: '$2' }}>
            {isSelectMode && (
                <Button
                    type="button"
                    variant="primary"
                    size="sm"
                    disabled={selectedCount === 0}
                    onClick={onArchiveSelected}
                    data-testid="bulk-archive-button"
                >
                    {t('request_details.bulk_archive.archive_selected', {
                        count: selectedCount,
                    })}
                </Button>
            )}
            <Button
                type="button"
                variant="secondary"
                size="sm"
                border="default"
                onClick={toggleSelectMode}
                data-testid="bulk-select-toggle"
            >
                {isSelectMode
                    ? t('request_details.bulk_archive.cancel')
                    : t('request_details.bulk_archive.select')}
            </Button>
        </Flex>
    );
}
